<page-loading-spinner [initialized]="initialized"></page-loading-spinner>
<div class="root" *ngIf="initialized">
  <p>reports works!</p>
</div>
